/**
 * Canonical viewport tiers — keep in sync with tailwind.config.js `screens`
 * and RESPONSIVE_DESIGN_SYSTEM.md.
 *
 * Product tiers:
 * - Mobile:  < 768px  (default Tailwind, no prefix)
 * - Tablet:  768–1023px  (`md:` / `tablet:`)
 * - Laptop:  1024–1439px (`lg:` / `laptop:`)
 * - Desktop: ≥ 1440px (`2xl:` / `desktop:`)
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440,
  desktop: 1440,
};

/** Inclusive upper bound for mobile tier (px). */
export const MOBILE_MAX_WIDTH = BREAKPOINTS.md - 1;

/** Inclusive lower bound for desktop tier (px) — matches `desktop:` / `2xl:` in Tailwind. */
export const DESKTOP_MIN_WIDTH = BREAKPOINTS.desktop;

/** Media query for mobile viewport — matches `isMobile` in useBreakpoint. */
export const MOBILE_VIEWPORT_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

/** Media query for desktop viewport — timesheet row layout and wide content caps. */
export const DESKTOP_VIEWPORT_QUERY = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;

export default BREAKPOINTS;
